import React from 'react';
import { Link } from 'react-router-dom';


function OwnerFooter() {

    return (
        <footer className="footer d-flex align-items-center justify-content-between">
            <ul>
                <li><p>©2020</p></li>
                <li><a href="https://www.mitsamtykke.dk/privatlivspolitik/" target="_blank" rel="noopener noreferrer">Privatlivspolitik</a></li>
                <li><a href="https://www.mitsamtykke.dk/brugervilkaar/" target="_blank" rel="noopener noreferrer">Brugsbetingelser</a></li>
            </ul>
            <Link to="/user/login">Admin login</Link>
        </footer>
    );
}

export default OwnerFooter;
